<div class="modal-header">
    <h4 class="modal-title">Gerenciar Treinamentos</h4>

    <button type="button" (click)="onDismiss()" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<!--Create-->
<div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="card">
        <div class="card-header">
            <h4>{{formTitle}}</h4>
        </div>
        <div class="card-body">
            <div class="modal-body" tabindex="0" ngbAutofocus>
                <h4></h4>
                <form class="form form-horizontal" [formGroup]="form" (submit)="handleSubmit()">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label class="form-control-label"  for="name">Nome</label>
                                <input uppercase type="text" name="name" id="name" formControlName="name"
                                    class="form-control" placeholder="Título" />
                                <app-error-msg [control]="form.controls['name']" [label]="'name'"></app-error-msg>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3 d-flex align-items-center justify-content-start">
                            <div class="form-group">
                                <div class="d-flex flex-column text">
                                    <label class="form-control-label" >Valida planejamento de HeadCount:</label>
                                    <div class="custom-control custom-switch custom-switch-success">
                                        <input type="checkbox" class="custom-control-input"
                                            id="validateHeadcountPlanning"
                                            formControlName="validateHeadcountPlanning" />
                                        <label class="form-control-label"class="custom-control-label" for="validateHeadcountPlanning">
                                            <span class="switch-icon-left"><i data-feather="check"></i></span>
                                            <span class="switch-icon-right"><i data-feather="x"></i></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3 d-flex align-items-center justify-content-start">
                            <div class="form-group">
                                <div class="d-flex flex-column text">
                                    <label class="form-control-label" >É aptidão?:</label>
                                    <div class="custom-control custom-switch custom-switch-success">
                                        <input type="checkbox" class="custom-control-input" id="isAptitude"
                                            formControlName="isAptitude" />
                                        <label class="form-control-label"class="custom-control-label" for="isAptitude">
                                            <span class="switch-icon-left"><i data-feather="check"></i></span>
                                            <span class="switch-icon-right"><i data-feather="x"></i></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12 btn-actions">
                            <button id="btn" type="submit" rippleEffect class="btn btn-primary me-2">Salvar</button>
                            <button type="reset" (click)="cleanForm()" rippleEffect
                                class="btn btn-secondary">Cancelar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<!--List-->
<div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="card">
        <div class="card-header">
            <h4>Listagem de Treinamentos</h4>
        </div>
        <div class="card-body">
            <div class="table-container">
                <table class="table table-responsive-lg table-bordered table-hover table-striped text-center">
                    <thead class="sticky-top">
                        <tr>
                            <th *ngFor="let field of fields">{{field}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of trainings; let i = index">
                            <td>
                                <i (click)="patchLevelValue(item.id)" class="feather icon-edit"></i>
                            </td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.creationDate | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ item.validateHeadcountPlanning ? "SIM" : "NÃO" }}</td>
                            <td>{{ item.isAptitude? "SIM" : "NÃO" }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>